<template>
    <div v-click-outside="closeIfOpened">
        <div @click="show = true" class="playlist-btn">
            Team Brew Queue
        </div>

        <transition name="slide">
            <div v-if="show" class="playlist-main-window" :class="{ 'overflow-visible': modalShown }">
                <header>
                    <h3>Your <strong>Brew Queue</strong></h3>
                    <div class="playlist-button-wrapper pointer-cursor" @click="show = false">
                        <div v-if="isManager">
                            <a href="/workplace/locations" >
                                <img src='~workplace/playlist-icon.svg' class="icon-brewlist-path" alt="Playlist">
                            </a>
                        </div>
                        <div v-else>
                            <img src='~workplace/playlist-icon.svg' class="icon-brewlist-path" alt="Playlist">
                        </div>
                    </div>

                </header>
                <div class="location-select-wrapper" v-show="locations && locations.length > 1">
                    <item-select
                            :array="locations"
                            :label="'Dept.'"
                            v-on:selected="locationSelected">
                    </item-select>
                </div>

                <nav>
                    <div v-for="(playlist, index) in playlists" class="nav-item" @click="selectedPlaylist = playlist" :class="getPlaylistTabClasses(playlist.id, index)">
                        {{ playlist.name }}
                    </div>
                </nav>

                <main>
                    <div v-show="selectedPlaylist">
                        <playlist
                                :playlist="selectedPlaylist"
                                :drag="drag"
                                :is-manager="isManager"
                                v-on:drag="toggleDrag"
                                v-on:refresh-suggestions="$refs.suggestions.fetchProducts()"
                                v-on:is-empty="updateIsPlaylistEmpty"
                                ref="playlist">
                        </playlist>

                        <playlist-buttons
                                v-if="selectedPlaylist && !selectedPlaylist.auto && isManager"
                                :playlist="selectedPlaylist"
                                v-on:auto="toggleAuto"
                                v-on:pause="togglePause"
                                v-on:repeat="toggleRepeat"
                                v-on:modal-toggled="modalToggled">
                        </playlist-buttons>

                        <playlist-suggestions
                                :playlist="selectedPlaylist"
                                :class="{ lowlight: drag }"
                                :is-playlist-empty="isPlaylistEmpty"
                                :is-manager="isManager"
                                v-on:drag="toggleDrag"
                                v-on:refresh-products="$refs.playlist.fetchProducts()"
                                ref="suggestions">
                        </playlist-suggestions>

                        <!-- TODO: Remove duplicated component here -->
                        <playlist-buttons
                                v-if="selectedPlaylist && selectedPlaylist.auto && isManager"
                                :playlist="selectedPlaylist"
                                v-on:auto="toggleAuto"
                                v-on:pause="togglePause"
                                v-on:repeat="toggleRepeat"
                                v-on:modal-toggled="modalToggled">
                        </playlist-buttons>
                    </div>
                </main>
            </div>
        </transition>
    </div>
</template>

<script>
    import ItemSelect from './item-select';
    import Playlist from './playlist';
    import PlaylistSuggestions from './playlist-suggestions';
    import PlaylistButtons from './playlist-buttons';
    import { ClickOutside } from '../../directives/click-outside'
    import _ from 'lodash'

    // Images
    import 'workplace/playlist-icon.png';

    export default {
        directives: {
            ClickOutside
        },
        components: {
            ItemSelect,
            Playlist,
            PlaylistSuggestions,
            PlaylistButtons
        },
        props: {
            locations: Array,
            managingLocationIds: Array,
            autoOpen: Boolean
        },
        data: function() {
            return  {
                show: false,
                selectedLocation: undefined,
                playlists: [],
                selectedPlaylist: undefined,
                drag: false,
                isPlaylistEmpty: undefined,
                modalShown: false,
            }
        },
        methods: {
            closeIfOpened() {
              if (this.show) {
                  this.show = false
              }
            },
            locationSelected(location) {
                this.selectedLocation = location;
                this.getPlaylists(this.selectedLocation.id)
            },
            getPlaylists(locationId) {
                this.$api.get('', { params: { locationId } })
                    .then(res => this.handlePlaylists(res.data))
                    .catch(console.error)
            },
            handlePlaylists(playlists) {
                this.playlists = playlists;
                if (this.playlists.length > 0)
                    this.selectedPlaylist = this.playlists[0];
            },
            toggleDrag(drag) {
                this.drag = drag;
            },
            toggleAuto() {
                const playlist = this.selectedPlaylist;
                playlist.auto = ! playlist.auto;
                this.$api.post('auto', { playlistId: playlist.id, auto: playlist.auto })
                    .then(() => this.onAutoToggled(playlist))
                    .catch((err) => {
                        playlist.auto = !playlist.auto;
                        console.error(err);
                    })
            },
            onAutoToggled(playlist) {
                if (playlist.auto) {
                    this.$refs.playlist.clearProducts();
                    this.$refs.suggestions.fetchProducts();
                    if (playlist.repeat) {
                        playlist.repeat = false;
                    }
                }
            },
            togglePause(resumeAt) {
                const playlist = this.selectedPlaylist;
                playlist.paused = ! playlist.paused;
                this.$api.post('pause', { playlistId: playlist.id, pause: playlist.paused, resumeAt })
                    .then(() => playlist.resume_at = resumeAt)
                    .catch((err) => {
                        playlist.paused = !playlist.paused;
                        console.error(err);
                    })
            },
            toggleRepeat() {
                const playlist = this.selectedPlaylist;
                playlist.repeat = ! playlist.repeat;
                this.$api.post('repeat', { playlistId: playlist.id, repeat: playlist.repeat })
                    .then(() => {})
                    .catch((err) => {
                        playlist.repeat = !playlist.repeat;
                        console.error(err);
                    })
            },
            getPlaylistTabClasses(playlistId, index) {
                if (!this.selectedPlaylist)
                    return '';

                return playlistId === this.selectedPlaylist.id ? 'selected-tab' : '';
            },
            updateIsPlaylistEmpty(isPlaylistEmpty) {
                // Can use v-model for this?
                this.isPlaylistEmpty = isPlaylistEmpty;
            },
            modalToggled(shown) {
                this.modalShown = shown;
            }
        },
        computed: {
            selectedTabIndex: function() {
                // Use lodash findIndex to support IE
                return _.findIndex(this.playlists, p => p.id === this.selectedPlaylist.id);
            },
            isManager: function() {
                if (!this.managingLocationIds || !this.selectedLocation) {
                    return false;
                }
                return this.managingLocationIds.includes(this.selectedLocation.id)
            }
        },
        mounted() {
            if (this.autoOpen) {
                setTimeout(() => {
                    this.show = true;
                }, 2000)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../styles/variables_workplace";

    .playlist-btn {
        color: $white;
        background-color: $color-primary;
        cursor: pointer;
        padding: 0 1.5rem;
        line-height: 30px;
        border-radius: 20px;
        font-weight: bold;
    }

    .playlist-main-window {
        box-sizing: border-box;
        position: fixed;
        z-index: 600;
        top: 0;
        right: 0;
        width: 27rem;
        height: 100%;
        background-color: #F4F7F1;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        -webkit-transition: right, 0.4s;
        -moz-transition: right, 0.4s;
        transition: right, 0.4s;
        box-shadow: -2px 0 6px 1px #888888;
    }

    /* Modals are not displayed properly when overflow is not visible on Safari */
    .overflow-visible {
        overflow: -webkit-paged-y;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #F4F7F1;
        background-color: #E15F60;
        padding: 2rem 1rem;
    }

    header h3 {
        margin: 0;
    }

    .location-select-wrapper {
        padding: 1rem 1.5rem;
        background-color: #E15F60;
    }

    nav {
        display: flex;
        width: 100%;
        color: #F4F7F1;
        background-color: #E15F60;
    }

    .nav-item {
        flex-grow: 1;
        text-align: center;
        padding: 1rem 2px 1rem 2px;
        flex-basis: 0;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .selected-tab {
        border-radius: 4px 4px 0 0;
        color: #E15F60;
        background-color: #F4F7F1;
    }

    .playlist-button-wrapper {
        width: 44px;
    }

    .slide-enter-active, .slide-leave-active {
        transition: transform .7s ease;
    }
    .slide-enter, .slide-leave-to {
        transform: translateX(27rem);
    }

    .lowlight {
        opacity: 0.7;
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        header {
            height: 44px;
        }
        nav {
            height: 50px;
        }
    }
</style>
